<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle />
        <b-card>
          <b-table :stacked="stacked" :dark="false" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
                   :fixed="fixed"
                   responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <b-button id="preview-image" @click="showModal(data.item.uri)" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')">
                </b-button>
              </div>

              <b-modal :id="data.item.uri + '-previewmodal'" title="Anteprima" button-size="sm" size="lg">
                <b-img v-if="selectedImagePreview" center :src="'data:image/jpeg;base64,'+ selectedImagePreview" fluid></b-img>
              </b-modal>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next" hide-goto-end-buttons/>
          </nav>

          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <router-link tag="button" class="btn btn-block btn-primary float-right col-2" role="button"
                             :to="{name: 'uploadImageNewRoute'}">{{ $t('actions.uploadimage') }}
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import UploadImageService from "@/services/UploadImageService"

  const uploadImageService = UploadImageService.build();

  export default {
    name: 'UploadImageList',
    components: {
      PageTitle
    },
    data() {
      return {
        currentPage: 1,
        items: [],
        selectedImagePreview: undefined
      }
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'name', label: 'Filename', sortable: true},
          {key: 'uri', label: 'URI', sortable: true},
          {key: 'actions', label: '', sortable: false},
        ]
      },
      perPage: {
        type: Number,
        default: 7
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      }
    },
    created() {
      this.fetchData();
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'})
    },
    methods: {
      async fetchData() {
        try{
          this.items = await uploadImageService.list()
        } catch (e) {
          miniToastr.error(e.message);
        }

      },
      async showModal(imageUrl) {
        this.$bvModal.show(imageUrl + '-previewmodal');
        try{
          const response = await uploadImageService.show(imageUrl);
          this.selectedImagePreview = response.imageFile;
        } catch (e) {
          miniToastr.error(e.message);
          this.$bvModal.hide(imageUrl + '-previewmodal');
        }
      },
      getRowCount: function () {
        return this.items.length
      }
    }
  }
</script>
